var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87453 8.64404H0.516724V25.9323H5.87453V8.64404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16845 6.38795C4.92266 6.38795 6.3369 4.96085 6.3369 3.19397C6.3369 1.42709 4.92266 0 3.16845 0C1.41424 0 0 1.42709 0 3.19397C0 4.96085 1.41424 6.38795 3.16845 6.38795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.428 16.8608C14.428 14.4279 15.5431 12.9872 17.6917 12.9872C19.6634 12.9872 20.6017 14.3735 20.6017 16.8608V25.9398H25.9324V14.9851C25.9324 10.3505 23.3078 8.10791 19.6362 8.10791C15.9646 8.10791 14.428 10.9621 14.428 10.9621V8.63797H9.28778V25.9262H14.428V16.8472V16.8608Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9459,
    height: 25.9459,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.12cf0dd160563511641805eaa64feafb.svg";
export { ForwardRef as ReactComponent };